import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ccff9c8")

_pushScopeId("data-v-8ccff9c8")
const _hoisted_1 = { class: "license-container" }
const _hoisted_2 = { class: "license-title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "line-bottom" }, null, -1)
const _hoisted_4 = { class: "license-pic-box" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.baseInfo.moduleName), 1),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.baseInfo.detailVOS, (itemPic, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: ["license-image", {
          'image-covered': itemPic.fieldCode == 'TECHNOLOGICAL_PROCESS_IMG'
        }],
          onClick: $event => (_ctx.showBig(index, itemPic))
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemPic.fieldContent.split(','), (srcItem, index) => {
            return (_openBlock(), _createBlock("img", {
              key: index,
              src: srcItem
            }, null, 8, ["src"]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createVNode("span", null, _toDisplayString(itemPic.fieldName), 1)
        ], 10, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
})